import React, { useState } from 'react';
import { HiMenu, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { images } from '../../constants';
import './Navbar.scss';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <nav className="app__navbar">
      {/* <div className="app__navbar-logo">
        <img src={images.logo} alt="logo" />
      </div> */}
      <ul className="app__navbar-links">
        {['home', 'about', 'skills', 'work',  'contact'].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
       <li className="app__flex p-text"> 
        <div />
        <a href="/resume.pdf" download>resume</a>
       </li>
      </ul>

{/* Phone Menu */}
      <div className="app__navbar-menu">
      <HiMenu className="pointer" onClick={() => setToggle(true)} />
        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <ul>
          <HiX className="set_to-black pointer" onClick={() => setToggle(false)} />
              {['home', 'about',  'skills', 'work',  'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
               <li className="app__flex p-text"> 
                 <a onClick={() => setToggle(false)} href="/resume.pdf" download>resume</a>
               </li>
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
